import { formatNumber } from "./web3/format-number"

export const getPercentValue = (current?: number, total?: number) => {
  if (typeof current === "undefined" || typeof total === "undefined") {
    return 100
  }
  if (total === 0) {
    return 0
  }
  if (current === 0) {
    return 100
  }
  const result = formatNumber((current / total) * 100, 1, 0)
  if (result < 0) {
    return 0
  }
  if (result > 100) {
    return 100
  }
  return result
}
